module.exports = __webpack_public_path__ + "static/cl-blanco2018-prod-34a7b34bedfbfefa48884cbb92e5d3d5.jpg";